import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import View from "react-native-web/dist/exports/View";
import Text from "react-native-web/dist/exports/Text";
import ScrollView from "react-native-web/dist/exports/ScrollView";
import TouchableOpacity from "react-native-web/dist/exports/TouchableOpacity";
import Dimensions from "react-native-web/dist/exports/Dimensions";
import PropTypes from 'prop-types';
import populateEvents from "./Packer";
import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import styleConstructor from "./style";
import { jsx as ___EmotionJSX } from "@emotion/core";
var LEFT_MARGIN = 60 - 1;
var TEXT_LINE_HEIGHT = 17;

function range(from, to) {
  return Array.from(Array(to), function (_, i) {
    return from + i;
  });
}

var _Dimensions$get = Dimensions.get('window'),
    dimensionWidth = _Dimensions$get.width;

var Timeline = function (_React$PureComponent) {
  _inherits(Timeline, _React$PureComponent);

  var _super = _createSuper(Timeline);

  function Timeline(props) {
    var _this;

    _classCallCheck(this, Timeline);

    _this = _super.call(this, props);
    var _this$props = _this.props,
        start = _this$props.start,
        end = _this$props.end;
    _this.calendarHeight = (end - start) * 100;
    _this.styles = styleConstructor(props.styles, _this.calendarHeight);
    var width = dimensionWidth - LEFT_MARGIN;
    var packedEvents = populateEvents(props.events, width, start);
    var initPosition = _.min(_.map(packedEvents, 'top')) - _this.calendarHeight / (end - start);
    var verifiedInitPosition = initPosition < 0 ? 0 : initPosition;
    _this.state = {
      _scrollY: verifiedInitPosition,
      packedEvents: packedEvents
    };
    return _this;
  }

  _createClass(Timeline, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var width = dimensionWidth - LEFT_MARGIN;
      var prevEvents = prevProps.events,
          _prevProps$start = prevProps.start,
          prevStart = _prevProps$start === void 0 ? 0 : _prevProps$start;
      var _this$props2 = this.props,
          events = _this$props2.events,
          _this$props2$start = _this$props2.start,
          start = _this$props2$start === void 0 ? 0 : _this$props2$start;

      if (prevEvents !== events || prevStart !== start) {
        this.setState({
          packedEvents: populateEvents(events, width, start)
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.scrollToFirst && this.scrollToFirst();
    }
  }, {
    key: "scrollToFirst",
    value: function scrollToFirst() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.state && _this2.state._scrollY && _this2._scrollView) {
          _this2._scrollView.scrollTo({
            x: 0,
            y: _this2.state._scrollY,
            animated: true
          });
        }
      }, 1);
    }
  }, {
    key: "_renderLines",
    value: function _renderLines() {
      var _this3 = this;

      var _this$props3 = this.props,
          format24h = _this$props3.format24h,
          _this$props3$start = _this$props3.start,
          start = _this$props3$start === void 0 ? 0 : _this$props3$start,
          _this$props3$end = _this$props3.end,
          end = _this$props3$end === void 0 ? 24 : _this$props3$end;
      var offset = this.calendarHeight / (end - start);
      var EVENT_DIFF = 20;
      return range(start, end + 1).map(function (i, index) {
        var timeText;

        if (i === start) {
          timeText = '';
        } else if (i < 12) {
          timeText = !format24h ? i + " AM" : i + ":00";
        } else if (i === 12) {
          timeText = !format24h ? i + " PM" : i + ":00";
        } else if (i === 24) {
          timeText = !format24h ? '12 AM' : '23:59';
        } else {
          timeText = !format24h ? i - 12 + " PM" : i + ":00";
        }

        return [___EmotionJSX(Text, {
          key: "timeLabel" + i,
          style: [_this3.styles.timeLabel, {
            top: offset * index - 6
          }]
        }, timeText), i === start ? null : ___EmotionJSX(View, {
          key: "line" + i,
          style: [_this3.styles.line, {
            top: offset * index,
            width: dimensionWidth - EVENT_DIFF
          }]
        }), ___EmotionJSX(View, {
          key: "lineHalf" + i,
          style: [_this3.styles.line, {
            top: offset * (index + 0.5),
            width: dimensionWidth - EVENT_DIFF
          }]
        })];
      });
    }
  }, {
    key: "_onEventTapped",
    value: function _onEventTapped(event) {
      if (this.props.eventTapped) {
        this.props.eventTapped(event);
      }
    }
  }, {
    key: "_renderEvents",
    value: function _renderEvents() {
      var _this4 = this;

      var packedEvents = this.state.packedEvents;
      var events = packedEvents.map(function (event, i) {
        var style = {
          left: event.left,
          height: event.height,
          width: event.width,
          top: event.top,
          backgroundColor: event.color ? event.color : '#add8e6'
        };
        var numberOfLines = Math.floor(event.height / TEXT_LINE_HEIGHT);
        var formatTime = _this4.props.format24h ? 'HH:mm' : 'hh:mm A';
        return ___EmotionJSX(TouchableOpacity, {
          activeOpacity: 0.9,
          onPress: function onPress() {
            return _this4._onEventTapped(_this4.props.events[event.index]);
          },
          key: i,
          style: [_this4.styles.event, style]
        }, _this4.props.renderEvent ? _this4.props.renderEvent(event) : ___EmotionJSX(View, null, ___EmotionJSX(Text, {
          numberOfLines: 1,
          style: _this4.styles.eventTitle
        }, event.title || 'Event'), numberOfLines > 1 ? ___EmotionJSX(Text, {
          numberOfLines: numberOfLines - 1,
          style: [_this4.styles.eventSummary]
        }, event.summary || ' ') : null, numberOfLines > 2 ? ___EmotionJSX(Text, {
          style: _this4.styles.eventTimes,
          numberOfLines: 1
        }, moment(event.start).format(formatTime), " -", ' ', moment(event.end).format(formatTime)) : null));
      });
      return ___EmotionJSX(View, null, ___EmotionJSX(View, {
        style: {
          marginLeft: LEFT_MARGIN
        }
      }, events));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return ___EmotionJSX(ScrollView, {
        ref: function ref(_ref) {
          return _this5._scrollView = _ref;
        },
        contentContainerStyle: [this.styles.contentStyle, {
          width: dimensionWidth
        }]
      }, this._renderLines(), this._renderEvents());
    }
  }]);

  return Timeline;
}(React.PureComponent);

_defineProperty(Timeline, "propTypes", {
  start: PropTypes.number,
  end: PropTypes.number,
  eventTapped: PropTypes.func,
  format24h: PropTypes.bool,
  events: PropTypes.arrayOf(PropTypes.shape({
    start: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
    color: PropTypes.string
  })).isRequired
});

_defineProperty(Timeline, "defaultProps", {
  start: 0,
  end: 24,
  events: [],
  format24h: true
});

export { Timeline as default };

if (typeof Timeline !== 'undefined' && Timeline && Timeline === Object(Timeline) && Object.isExtensible(Timeline) && !Timeline.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Timeline, '__filemeta', {
    configurable: true,
    value: {
      name: "Timeline",
      filename: "node_modules/react-native-calendars/src/timeline/Timeline.js"
    }
  });
}

if (typeof Timeline !== 'undefined' && Timeline && Timeline === Object(Timeline) && Object.isExtensible(Timeline) && !Timeline.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Timeline, '__filemeta', {
    configurable: true,
    value: {
      name: "Timeline",
      filename: "node_modules/react-native-calendars/src/timeline/Timeline.js"
    }
  });
}